import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorConfigure } from 'app/e-form/config/validator';
import { LanguageItem } from 'app/e-form/model/lookup';
import { EFormHelper } from './helper';

export class LookUpConverter {
   helper = new EFormHelper();
   validators = new ValidatorConfigure();
   defaultValue: any;
   constructor(public eForm: any, private fb: FormBuilder) {
      this.defaultValue = '';
   }

    _prepareChoices = (arr, group) => {
      arr.forEach((response, index) => {
         group.push(this.fb.group({
            label: this.fb.group({
               th: response.label.th,
               en: response.label.en,
               cn: response.label.cn,
            }),
            value: [response.value],
            isPrompt: response.isPrompt
         }));
      });
   }

   _filterObjects(lookup: any) {
      const _tmpObjects  = [];
      const langItems = lookup.languageItems[0] as LanguageItem;
      langItems.languageStaticData.forEach(v => {
         v.items.choiceDataSourceEntity.forEach((items, index)  => {
            this.defaultValue = items.isDefaultValue ? items.valueMember : '' ;
            if (_tmpObjects[index] === undefined) {
               _tmpObjects.push({label : {[v.language]: items.displayMember}, value: items.valueMember, isPrompt: items.valueMember === ''});
            } else {
               Object.assign(_tmpObjects[index].label, {[v.language]: items.displayMember});
            }
         });
      });
      return _tmpObjects;
   }




}
